<script setup lang="ts">

const { page, toc } = useContent()

page.value.tocBeginning = true

const isAPISidebar = page.value?.sidebar == 'API'

const tocTitle = computed(
    () => page.value?.toc_title
)

</script>

<template>
    <div class="flex flex-col">
        <template v-if="toc?.links?.length">
            <div class="items-center overflow-hidden font-semibold lg:flex">
                <span class="text-xl pw-text-black">{{ tocTitle || 'Table of Contents' }}</span>
            </div>

            <DocsTocLinksInContent v-if="isAPISidebar" :links="toc.links" class="text-lg ml-2" />
            <DocsTocLinksInContent v-else :links="toc.links" class="text-lg ml-2" />
        </template>
    </div>
</template>
